import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BookingService} from '../services/booking.service'
import { BookingGuestService } from '../services/booking-guest.service';
import { GuestDetail, GuestTemplate } from './guest-detail.model';
import { Modal, Toast } from 'bootstrap';
import { getBoatImageUrl, getGuestDocumentUrl } from '../utils/image-url.util';

@Component({
  selector: 'app-detail-booking',
  templateUrl: './detail-booking.component.html',
  styleUrls: ['./detail-booking.component.css']
})
export class DetailBookingComponent implements OnInit, OnDestroy {
  kodeBooking: string = '';
  bookings: any = [];
  paymentCountdown: string = '';
  remainingMinutes: number = 0; // Stores remaining time in minutes
  countdownInterval: any;

  tamu:any = [];

  errorMessage: string | null = null;
  tgl:string = '';
  imgUrl : string = '';

  idpel : number | null = null;

  isModalVisible: boolean = false;
  ketBatal: string = '';  // To store the cancellation explanation
  selectedPaymentMethod: string = '';

  private modalPayment!: Modal;


  link_payment : string = '';

  // Guest details
  guestForm!: FormGroup;
  guestFiles: (File | null)[] = [];
  templates: GuestTemplate[] = [];
  savingGuests = false;
  editingGuestIndex: number | null = null;

  constructor(
    private route: ActivatedRoute,
    public bookService: BookingService,
    private fb: FormBuilder,
    private bookingGuestService: BookingGuestService,
  ) { }
  ngOnInit(): void {
    this.kodeBooking = this.route.snapshot.paramMap.get('kode_booking')!;
    this.load_data();

    setTimeout(() => {
      this.modalPayment = new Modal(document.getElementById('paymentModal')!);
    });
  }

  load_data():void{
    const kode_booking = this.kodeBooking;
    if (kode_booking) {
      this.bookService.getDetailBooking(kode_booking).subscribe(
        (res) => {
          this.bookings = res.data;  
          
          if (this.bookings.status === 'WAITING PAYMENT') {
            this.startCountdown();

                this.bookService.getInvoiceStatus(kode_booking).subscribe(
                (res) => {
                  const invoiceStatus = res.data.invoiceStatus.status;
                  const id = res.data.invoiceStatus.id;

                

                  // Base Xendit checkout URL
                  let baseUrl = `https://checkout.xendit.co/web/${id}`;

                  if (invoiceStatus ){
                    this.link_payment = `${baseUrl}`;

                    
                  }

                  // Tambahkan query parameter method jika tersedia
                
                },
                (error) => {
                  this.errorMessage = 'Failed to load Invoice';
                  this.link_payment = '';
                  console.error(error);
                }
              );

          }
         
          const tgl_mulai = new Date(this.bookings.start_date.trim());
          const tgl_sampai = new Date(this.bookings.end_date.trim());
          const parsedDatemulai =  tgl_mulai.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
          const parsedDatesampai =  tgl_sampai.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
          this.tgl = parsedDatemulai +' - '+parsedDatesampai;

          this.imgUrl = getBoatImageUrl(this.bookings.gambar_kapal);

          this.idpel = this.bookings.id_pelanggan;
          if (this.idpel)
          {
            this.bookService.getPelangganById(this.idpel).subscribe(
              (res) => {
                this.tamu = res;
                // console.log(this.tamu);
              },
              (error) => {
                this.errorMessage = 'Failed to load bookings';
                console.error(error);
              }
            );
          }

          if (this.bookings.status === 'CANCELLED') {
            this.ketBatal = this.bookings.ket_batal || 'No cancellation reason provided.';
          }

          this.initGuestForm();
        },
        (error) => {
          this.errorMessage = 'Failed to load bookings';
          console.error(error);
        }
      );

    //  if (this.bookings.status === 'WAITING PAYMENT') 
    //   {

        
       
    //   }

       
    }
  }

  startCountdown(): void {
    if (!this.bookings.paymentDue) return;

    const paymentDueDate = new Date(this.bookings.paymentDue).getTime();

    this.countdownInterval = setInterval(() => {
      const now = new Date().getTime();
      const timeLeft = paymentDueDate - now;

      if (timeLeft <= 0) {
        clearInterval(this.countdownInterval);
        this.paymentCountdown = 'Expired';
        this.remainingMinutes = 0;

           this.bookService.expireBook(this.bookings.id).subscribe({
            next: (res) => {
              console.log('Invoice expired :', res);
              this.bookings.status = 'EXPIRED'; // Update status tampilan
            },
            error: (err) => {
              console.error('Fail to expire invoice:', err);
            }
          });
        return;
      }

      const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
      const seconds = Math.floor((timeLeft / 1000) % 60);

      this.paymentCountdown = `${hours}h ${minutes}m ${seconds}s`;
      this.remainingMinutes = hours * 60 + minutes; // Convert to total minutes

    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }


  getAccomodationText(): string {
    if (this.bookings?.BookingAcc?.length > 0) {
      return this.bookings.BookingAcc.map((acc:any) => acc.name).join(', ');
    } else {
      return 'Entire Place';
    }
  }


  statusClasses = [
    { status: 'PENDING', class: 'text-bg-primary' },
    { status: 'CONFIRMED', class: 'text-bg-success' },
    { status: 'CANCELLED', class: 'text-bg-danger' },
    { status: 'WAITING PAYMENT', class: 'text-bg-warning' },
    { status: 'PAID', class: 'text-bg-success' },
    { status: 'SETTLED', class: 'text-bg-success' },
    { status: 'EXPIRED', class: 'text-bg-danger' },
    { status: 'REFUNDED', class: 'text-bg-warning' } 
  ];
  
  getStatusClass(): string {
    if (!this.bookings || !this.bookings.status) {
      return 'text-bg-secondary'; // Default jika status tidak ditemukan
    }
    const status = this.statusClasses.find(item => item.status === this.bookings.status);
    return status ? status.class : 'text-bg-secondary';
  }
  
  getFormattedStatus(): string {
    if (!this.bookings || !this.bookings.status) {
      return 'Unknown'; // Default jika status tidak ditemukan
    }
    return this.bookings.status.charAt(0).toUpperCase() + this.bookings.status.slice(1);
  }

  slugify(a: string = ''): string {
    const hasil = a
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
      
    return hasil;
  }

  onStatusClick(): void {
    if (this.bookings.status === 'CANCELLED') {
      this.isModalVisible = true;
    }
  }

  closeModal(): void {
    this.isModalVisible = false;
  }

  openPaymentModal() : void {
   
    window.open(this.link_payment, '_blank');

  }

  selectPaymentMethod(method: string) {
    this.selectedPaymentMethod = method;
    console.log('Selected Payment:', method);
    alert(`You selected: ${method}`);
    
    // Simulasi proses pembayaran (bisa ganti dengan API call)
    setTimeout(() => {
     
      this.modalPayment.hide();
    }, 1000);
  }


getPaymentMethodLabel(method: string): string {
  if (!method) return 'Unknown Method';

  const lower = method.toLowerCase();

  if (lower === 'credit card') {
    return 'Credit Card';
  }

  // Bank map untuk transfer
  const bankMap: { [key: string]: string } = {
    'BNI': 'Bank Negara Indonesia (BNI)',
    'BSI': 'Bank Syariah Indonesia (BSI)',
    'BRI': 'Bank Rakyat Indonesia (BRI)',
    'CIMB': 'CIMB Niaga',
    'PERMATA': 'Permata Bank',
    'MANDIRI': 'Bank Mandiri'
  };

  if (bankMap[method]) {
    return `Bank Transfer - ${bankMap[method]}`;
  }

  return 'Unknown Method';
}


  // ---------- Guest details ----------

  initGuestForm(): void {
    const count = Number(this.bookings?.guests) || 0;
    this.guestForm = this.fb.group({ guests: this.fb.array([]) });
    this.guestFiles = new Array(count).fill(null);

    const kodeBooking = this.bookings?.kode_booking;
    const applyServerGuests = (serverGuests: GuestDetail[]) => {
      const byIndex = new Map<number, GuestDetail>();
      for (const g of serverGuests) byIndex.set(g.guest_index, g);
      for (let i = 0; i < count; i++) {
        this.guestsArray.push(this.makeGuestGroup(byIndex.get(i)));
      }
    };

    if (kodeBooking) {
      this.bookingGuestService.getGuestsByBooking(kodeBooking).subscribe({
        next: (list) => applyServerGuests(list || []),
        error: () => applyServerGuests([]),
      });
    } else {
      applyServerGuests([]);
    }

    this.templates = this.getCurrentCustomerId()
      ? this.bookingGuestService.getTemplates(this.getCurrentCustomerId()!)
      : [];
  }

  get guestsArray(): FormArray {
    return this.guestForm.get('guests') as FormArray;
  }

  makeGuestGroup(seed?: Partial<GuestDetail>): FormGroup {
    return this.fb.group({
      full_name: [seed?.full_name || '', Validators.required],
      date_of_birth: [seed?.date_of_birth || ''],
      gender: [seed?.gender || ''],
      nationality: [seed?.nationality || ''],
      document_type: [seed?.document_type || 'passport'],
      document_number: [seed?.document_number || '', Validators.required],
      document_expiry: [seed?.document_expiry || ''],
      document_file_url: [seed?.document_file_url || ''],
      document_file_name: [seed?.document_file_name || ''],
      document_view_token: [seed?.document_view_token || ''],
      emergency_contact_name: [seed?.emergency_contact_name || ''],
      emergency_contact_phone: [seed?.emergency_contact_phone || ''],
      dietary: [seed?.dietary || ''],
      allergy: [seed?.allergy || ''],
      medical_notes: [seed?.medical_notes || ''],
      dive_certification: [seed?.dive_certification || ''],
      flipper_size: [seed?.flipper_size || ''],
      pickup_location: [seed?.pickup_location || ''],
      dropoff_location: [seed?.dropoff_location || ''],
    });
  }

  openGuestModal(i: number): void {
    this.editingGuestIndex = i;
    document.body.classList.add('modal-open');
  }

  closeGuestModal(): void {
    this.editingGuestIndex = null;
    document.body.classList.remove('modal-open');
  }

  get editingGuestGroup(): FormGroup | null {
    if (this.editingGuestIndex === null || !this.guestForm) return null;
    return this.guestsArray.at(this.editingGuestIndex) as FormGroup;
  }

  onDocumentSelected(i: number, event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0] ? input.files[0] : null;
    this.guestFiles[i] = file;
    this.guestsArray
      .at(i)
      .patchValue({ document_file_name: file ? file.name : '' });
  }

  findTemplate(id: string): GuestTemplate | undefined {
    return this.templates.find((t) => t.id === id);
  }

  loadTemplate(i: number, template: GuestTemplate | undefined): void {
    if (!template) return;
    this.guestsArray.at(i).patchValue(template.guest);
    this.guestFiles[i] = null;
  }

  saveAsTemplate(i: number): void {
    const idPelanggan = this.getCurrentCustomerId();
    if (!idPelanggan) {
      alert('Please log in to save a guest template.');
      return;
    }
    const g = this.guestsArray.at(i).value as GuestDetail;
    if (!g.full_name) {
      alert('Please fill in the guest name before saving as a template.');
      return;
    }
    const name = (prompt('Template name:', g.full_name) || '').trim();
    if (!name) return;
    const { full_name, date_of_birth, gender, nationality, document_type,
      document_number, document_expiry, document_file_url, document_file_name,
      emergency_contact_name, emergency_contact_phone, dietary, allergy,
      medical_notes, dive_certification, flipper_size,
      pickup_location, dropoff_location } = g;
    const payload = {
      full_name, date_of_birth, gender, nationality, document_type,
      document_number, document_expiry, document_file_url, document_file_name,
      emergency_contact_name, emergency_contact_phone, dietary, allergy,
      medical_notes, dive_certification, flipper_size,
      pickup_location, dropoff_location,
    };
    this.bookingGuestService.saveTemplate(idPelanggan, name, payload);
    this.templates = this.bookingGuestService.getTemplates(idPelanggan);
    alert('Template saved.');
  }

  saveAllGuests(): void {
    if (!this.guestForm || this.guestForm.invalid) {
      this.guestForm.markAllAsTouched();
      alert('Please fill in all required fields (name and document number) for each guest.');
      return;
    }
    const kodeBooking = this.bookings?.kode_booking;
    if (!kodeBooking) return;

    this.savingGuests = true;

    const guestValues = this.guestsArray.controls.map((ctrl, i) => {
      const v = ctrl.value as GuestDetail;
      return { ...v, kode_booking: kodeBooking, guest_index: i } as GuestDetail;
    });

    const uploadTasks: Promise<void>[] = this.guestFiles.map((file, i) => {
      if (!file) return Promise.resolve();
      return new Promise<void>((resolve) => {
        this.bookingGuestService
          .uploadGuestDocument(kodeBooking, i, file)
          .subscribe({
            next: (res) => {
              guestValues[i].document_file_url = res?.url || '';
              resolve();
            },
            error: () => resolve(), // continue even if upload fails
          });
      });
    });

    Promise.all(uploadTasks).then(() => {
      this.bookingGuestService.saveGuests(kodeBooking, guestValues).subscribe({
        next: (savedRows) => {
          for (const g of savedRows || []) {
            const ctrl = this.guestsArray.at(g.guest_index);
            if (!ctrl) continue;
            ctrl.patchValue({
              document_view_token: g.document_view_token || '',
              document_file_url: g.document_file_url || '',
              document_file_name: g.document_file_name || '',
            });
          }
          this.guestFiles = new Array(this.guestsArray.length).fill(null);
          this.savingGuests = false;
          alert('Guest details saved.');
        },
        error: () => {
          this.savingGuests = false;
          alert('Failed to save guest details. The backend endpoint may not be available yet.');
        },
      });
    });
  }

  private getCurrentCustomerId(): number | null {
    const id = this.bookings?.id_pelanggan;
    return typeof id === 'number' && id > 0 ? id : null;
  }

  getDocumentUrl(i: number): string {
    const kode = this.bookings?.kode_booking;
    if (!kode || !this.guestForm) return '';
    const v = this.guestsArray.at(i)?.value as GuestDetail | undefined;
    const token = v?.document_view_token || '';
    if (!token) return '';
    return getGuestDocumentUrl(kode, i, token);
  }

  isImageFile(filename: string): boolean {
    if (!filename) return false;
    return /\.(jpe?g|png|gif|webp)$/i.test(filename);
  }

}
